import { Navigate, Outlet, useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'

import { useAuth } from './context'

/**
 * Route guard around the app shell. While the silent refresh decides whether a session
 * exists, nothing protected renders — not even for a flash.
 */
export function RequireAuth() {
  const { status } = useAuth()
  const { t } = useTranslation()
  const location = useLocation()

  if (status === 'initializing') {
    return <p className="session-check">{t('auth.checkingSession')}</p>
  }

  if (status === 'anonymous') {
    // Remember where the visitor was heading; LoginPage returns them there.
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  return <Outlet />
}
